export const environment = {
    apiUrl: 'https://nodeapi.test.doc.inncircles.ai',
    prospectUrl: 'https://code.beta.inncirclesarena.com',
    ioSocketUrl: 'https://nodeapi.test.doc.inncircles.ai',
    wsSocketUrl: 'wss://nodeapi.test.doc.inncircles.ai/ws',
    s3Url: 'https://inncircles-ai-test-public-0414.s3.us-east-2.amazonaws.com',
    jwtSecret: "inndoc_secret",
    onlyOfficeServer: "https://onlyoffice.test.inncircles.ai",
    innDocAgentUrl: "https://test.chat.inncircles.ai",
    enableSubscription: true,
    loadTanStackDevTools: false,
    environment: 'test'
};
